/**
 * Lifecycle of a CancellationFee (TM-9064 Ausfallhonorar):
 * - `PENDING`: snapshotted from the `cancellation-fee.owed` event, awaiting
 *   the practice's decision (Berechnen vs. Erlassen).
 * - `INVOICED`: charged via a standalone non-taxable Schadensersatz invoice
 *   (slice 4, #857).
 * - `WAIVED`: explicitly forgiven by the practice (slice 3, #856).
 */
export var CancellationFeeStatus;
(function (CancellationFeeStatus) {
    CancellationFeeStatus["PENDING"] = "pending";
    CancellationFeeStatus["INVOICED"] = "invoiced";
    CancellationFeeStatus["WAIVED"] = "waived";
})(CancellationFeeStatus || (CancellationFeeStatus = {}));
//# sourceMappingURL=cancellation-fee-status.enum.js.map